// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__23TA6","buttons":"Footer_buttons__3ih1W"};